export const cardClass =
  "rounded-lg border bg-card text-card-foreground shadow-sm";

export const mobileCardClass =
  "rounded-lg border bg-[#113F67]/5 text-card-foreground shadow-sm";

export const cardHeaderClass = "flex flex-col space-y-1.5 p-6";

export const cardTitleClass =
  "text-2xl font-semibold leading-none tracking-tight";

export const cardDescriptionClass = "text-sm text-muted-foreground";

export const cardContentClass = "p-6 pt-0";

export const cardContentFlushClass = "p-0";

export const cardFooterClass = "flex items-center p-6 pt-0";

export const pageTitleClass = "font-semibold text-xl md:text-2xl text-[#113F67]";

export const fieldLabelClass = "text-sm font-semibold text-[#113F67]";

export const filterLabelClass = "text-sm font-medium";

export const filterTitleClass = "font-semibold tracking-tight text-lg";

export const fieldIconClass =
  "absolute left-4 z-[1] top-3.5 h-5 w-5 text-[#34699A]";

export const formFieldIconClass = "absolute left-4 top-4 h-5 w-5 text-[#34699A]";

export const formSelectIconClass =
  "absolute left-4 z-[1] top-4 h-5 w-5 text-[#34699A]";

export const fieldErrorIconClass = "absolute right-4 top-4 h-5 w-5 text-red-500";

export const fieldErrorTextClass =
  "text-red-500 text-sm flex items-center mt-1";

export const fieldInputClass = (hasError?: boolean): string =>
  `pl-12 h-12 text-base border-2 rounded-lg transition-all duration-200 ${
    hasError
      ? "border-red-500 focus:border-red-500 focus:ring-red-500"
      : "border-gray-200 focus:border-[#113F67] focus:ring-[#113F67]"
  }`;

export const filterFooterClass = "flex gap-2 mt-4 pt-4 border-t justify-end";

export const tableHeadCellClass = "font-semibold text-[#113F67]";

export const buttonSpinnerClass =
  "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2";

export const actionBarClass =
  "flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center";

export const actionBarEndClass =
  "flex flex-col sm:flex-row gap-4 justify-end items-start sm:items-center";

export const filterGridClass =
  "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4";

export const fieldTextareaClass = (hasError?: boolean): string =>
  `pl-12 min-h-[80px] text-base border-2 rounded-lg transition-all duration-200 ${
    hasError
      ? "border-red-500 focus:border-red-500 focus:ring-red-500"
      : "border-gray-200 focus:border-[#113F67] focus:ring-[#113F67]"
  }`;

export const dialogTitleClass =
  "tracking-tight text-xl font-semibold text-[#113F67]";

export const dialogInputClass = (hasError?: boolean): string =>
  `pl-12 h-12 text-base border-2 rounded-lg transition-all duration-200 ${
    hasError
      ? "border-red-500 focus:border-red-500"
      : "border-gray-200 focus:border-[#113F67]"
  }`;

export const dialogTextareaClass = (hasError?: boolean): string =>
  `pl-12 min-h-[80px] text-base border-2 rounded-lg transition-all duration-200 ${
    hasError
      ? "border-red-500 focus:border-red-500"
      : "border-gray-200 focus:border-[#113F67]"
  }`;

export const dialogMobileContentClass =
  "max-sm:inset-0 max-sm:flex max-sm:max-h-none max-sm:max-w-none max-sm:translate-x-0 max-sm:translate-y-0 max-sm:flex-col max-sm:gap-0 max-sm:border-0 max-sm:p-0";

export const dialogMobileHeaderClass =
  "max-sm:border-b max-sm:px-6 max-sm:pb-4 max-sm:pt-6";

export const dialogMobileFormClass =
  "max-sm:flex max-sm:min-h-0 max-sm:flex-1 max-sm:flex-col max-sm:space-y-0";

export const dialogMobileBodyClass =
  "max-sm:min-h-0 max-sm:flex-1 max-sm:overflow-y-auto max-sm:px-6 max-sm:py-4";

export const dialogMobileFooterClass = "max-sm:px-6 max-sm:pb-6";

export const summaryLabelClass = "text-base font-bold text-gray-600";

export const summaryValueClass = "text-lg font-bold text-primary";

export const moneyCellClass = "text-right font-semibold text-primary";

export const segmentTrackClass = "flex items-center bg-gray-100 rounded-lg p-1";

export const segmentButtonClass =
  "inline-flex h-10 items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2";

export const segmentActiveClass =
  "bg-[#113F67] hover:bg-[#0d2f4f] text-white shadow-sm";

export const segmentInactiveClass =
  "text-gray-600 hover:text-gray-900 hover:bg-transparent";

export const arrayRowClass =
  "grid grid-cols-1 md:grid-cols-12 gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200";

export const arrayAddButtonClass =
  "flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:text-accent-foreground h-10 px-4 py-2 w-full md:w-56 ml-auto border-2 border-dashed border-[#113F67]/30 hover:border-[#113F67] hover:bg-[#113F67]/5 bg-transparent";

export const arrayRemoveButtonClass =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border-2 border-input bg-background h-12 w-12 text-red-600 hover:text-red-700 hover:bg-red-50";

// The size tables of the item page and the party ભાવ page: a header, a common row whose rates go to every size, then
// a row per size with "border-t border-gray-200" from the second one on. The size column is 3 wide; the other cells
// set their own spans.
export const sizeTableClass =
  "overflow-hidden rounded-lg border border-gray-200 bg-white";

export const sizeTableHeadClass =
  "hidden border-b border-gray-200 bg-[#113F67]/5 px-4 py-2 md:grid md:grid-cols-12 md:gap-x-4";

export const sizeTableCommonRowClass =
  "grid grid-cols-1 gap-x-4 gap-y-2 border-b border-gray-200 bg-[#34699A]/5 p-4 md:grid-cols-12 md:items-center md:py-2";

// A common row in a box of its own, inside sizeTableClass: the ભાવ page's row for a main item and its sub items. Like
// the tables' common row without the line under it, so its columns line up with theirs.
export const commonRateRowClass =
  "grid grid-cols-1 gap-x-4 gap-y-2 bg-[#34699A]/5 p-4 md:grid-cols-12 md:items-center md:py-2";

export const sizeTableRowClass =
  "grid grid-cols-1 gap-x-4 gap-y-2 p-4 md:grid-cols-12 md:items-center md:py-2";

export const sizeTableSizeCellClass =
  "flex min-w-0 items-center gap-2 font-semibold text-[#113F67] md:col-span-3";

export const gradientSubmitButtonClass =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 py-2 h-10 px-6 bg-gradient-to-r from-[#113F67] to-[#34699A] hover:from-[#0d2f4d] hover:to-[#2a547b] text-white font-semibold text-base rounded-lg transition-all duration-300 transform hover:scale-[1.01] hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none";

export const formCardClass =
  "rounded-lg text-card-foreground w-full shadow-lg border-0 bg-white/80 backdrop-blur-sm";

export const summaryCardTitleClass =
  "text-sm font-medium leading-none tracking-tight text-gray-500";

export const summaryCardValueClass =
  "text-2xl font-bold text-primary text-right";

export const creditCellClass = "text-right font-semibold text-green-800";

export const debitCellClass = "text-right font-semibold text-orange-800";

export const creditTextClass = "text-green-800 font-semibold";

export const debitTextClass = "text-orange-800 font-semibold";

// The material order and purchase detail pages copy the user's reference app: one card whose parts are split by lines.
export const detailCardClass =
  "rounded-lg bg-white p-4 text-card-foreground shadow-lg sm:p-6";

export const detailSectionClass = "mt-6 border-t pt-6";

export const detailSectionTitleClass =
  "flex items-center gap-2 text-lg font-semibold text-[#113F67]";

export const detailInfoLabelClass = "text-sm font-medium text-[#113F67]";

export const detailTableWrapClass = "overflow-hidden rounded-lg border";

export const detailTableHeadRowClass = "bg-[#113F67]/5 hover:bg-[#113F67]/5";

// The ક્રમ and ફોટો columns at the start of a lines table: narrow and fixed (the photo cell fits its 40px photo), so the
// material column takes the rest of the width and the photo and the material name sit on the left.
export const detailIndexHeadClass = "w-16 font-semibold text-[#113F67]";

export const detailPhotoHeadClass = "w-[72px] font-semibold text-[#113F67]";

// The number columns at the end of a lines table (qty, received, pending; qty, rate, amount): the same width, size and
// navy colour, right-aligned, so they read as one block. Their header, a cell, and the totals row's cell. The smaller
// left padding (pl-2, after the cells' own p-4/px-4 in the CSS) fits an amount up to 9,99,999.99 in the width, so the
// columns stay equal; the table still leaves the material column room at 640px.
export const detailNumberHeadClass =
  "w-28 pl-2 text-right font-semibold text-[#113F67]";

export const detailNumberCellClass =
  "w-28 whitespace-nowrap pl-2 text-right font-semibold text-[#113F67]";

export const detailNumberTotalClass =
  "whitespace-nowrap pl-2 text-right font-bold text-[#113F67]";
